export default __webpack_public_path__ + "static/media/logo.1ff8efac.png";